/** Sincroniza la bandeja de Pedidos cuando Cocina u otro módulo cambia un pedido (misma máquina, varias pestañas). */

const CHANNEL_NAME = 'pizas-orders-sync';
const STORAGE_KEY = 'pizas-orders-bump';

export function notifyOrdersChanged() {
  const ts = String(Date.now());
  try {
    localStorage.setItem(STORAGE_KEY, ts);
  } catch {
    /* ignore */
  }
  try {
    const ch = new BroadcastChannel(CHANNEL_NAME);
    ch.postMessage({ ts });
    ch.close();
  } catch {
    /* ignore */
  }
}

export function subscribeOrdersChanged(onRefresh) {
  let channel = null;
  try {
    channel = new BroadcastChannel(CHANNEL_NAME);
    channel.onmessage = () => onRefresh();
  } catch {
    /* ignore */
  }

  const onStorage = (e) => {
    if (e.key === STORAGE_KEY) onRefresh();
  };
  window.addEventListener('storage', onStorage);

  const onVisible = () => {
    if (document.visibilityState === 'visible') onRefresh();
  };
  document.addEventListener('visibilitychange', onVisible);
  window.addEventListener('focus', onVisible);

  return () => {
    if (channel) {
      channel.close();
      channel = null;
    }
    window.removeEventListener('storage', onStorage);
    document.removeEventListener('visibilitychange', onVisible);
    window.removeEventListener('focus', onVisible);
  };
}
